export function normalizeProductId(id: any): number | null {
  if (id == null) {
    return null;
  }
  if (typeof id === "number") {
    return id;
  }

  const raw = String(id).trim();
  const docIdMatch = raw.match(/^d:[^:]+:(\d+)$/);
  if (docIdMatch) {
    return Number(docIdMatch[1]);
  }
  if (/^\d+$/.test(raw)) {
    return Number(raw);
  }

  return null;
}

export function buildSemifinishedProductComboboxItems(
  documents: any[],
  excludeId?: any
) {
  const exclude = normalizeProductId(excludeId);

  return (documents || [])
    .filter((row: any) => {
      if (exclude == null) {
        return true;
      }
      return normalizeProductId(row.id) !== exclude;
    })
    .map((row: any) => ({
      id: row.id,
      label: row.name
    }));
}
